<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch3">
<div class="chapterHead"><p class="centerImage0"><img alt="image" src="images/ch3.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">“Yeow!” you cry, jerking away from the vicious dog.</p>
<p class="para" style="text-indent: 5%;">But Buttermilk is fast. He lunges at you, baring long, sharp fangs. His hot breath stinks.</p>
<p class="para" style="text-indent: 5%;">Oh, no. He’s a vampire dog, too!</p>
<p class="para" style="text-indent: 5%;">“Get off, Buttermilk!” you command. You push him away and scramble to your feet.</p>
<p class="para" style="text-indent: 5%;">Buttermilk lunges at you!</p>
<p class="para" style="text-indent: 5%;">“Yikes!” you shout. You dash across the Berklines’ yard and jump the fence. You run around to the back.</p>
<p class="para" style="text-indent: 5%;">There, on the back patio, are three more dogs. All bitten in the neck. All changing into vampire dogs!</p>
<p class="para" style="text-indent: 5%;">Two of them are dachshunds. The third is a big mutt. They lift their heads and sniff the air.</p>
<p class="para" style="text-indent: 5%;">Then they all howl and leap at you!</p>
<p class="para" style="text-indent: 5%;">You race to the gate. Then skid to a stop.</p>
<p class="para" style="text-indent: 5%;">Buttermilk is waiting just outside the fence!</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Turn to <span href="#/e9780545820660_ch020" title="Link target outside of Sample">PAGE 20</span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545820660_ch003.vue?0006d00c